import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/**
 * HTTP interceptor that handles 401/403 responses by redirecting appropriately.
 *
 * Bearer token injection is handled by the SDK's Configuration.credentials.bearerAuth
 * callback configured in provideApi() (see app.config.ts).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 403) {
        console.warn('403 Forbidden: Redirecting to unauthorized page');
        router.navigate(['/unauthorized']);
      }
      return throwError(() => error);
    })
  );
};
